var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import parse from "html-react-parser";
import styled from "styled-components";
export var PlainText = function (_a) {
    var text = _a.text, className = _a.className, _b = _a.as, as = _b === void 0 ? "div" : _b;
    var body = typeof text === "string" ? parse(text) : text;
    return React.createElement(PlainTextDiv, { className: className, as: as }, body);
};
var PlainTextDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
